import React from 'react'
import { EMAILS } from 'shared-constants'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Box } from 'components/Layout'
import { QA } from 'components/QA'
import { H1, H2 } from 'components/Typography'
import { SPACE } from 'Theme'
import { prepareGetStaticNavigationProps } from '../utils/prepareGetStaticNavigationProps'

const Docs = () => (
  <Box mt={SPACE.PX_80} mb={SPACE.PX_120}>
    <H1>Docs</H1>
    <H2 id="forclients">For Experts:</H2>

    <QA title="How to install Zoom to The Expert?">
      <QA.Text>Let&#39;s start with setting up your account at Zoom:</QA.Text>
      <QA.Wrapper>
        <ul>
          <li>
            <b>I do not have a Zoom account.</b> If you do not already have a
            Zoom account, create one{' '}
            <a target="_blank" rel="noreferrer" href="https://zoom.us/signup">
              HERE
            </a>
            . Please note, in order to start offering consultations you must
            have at least a Pro-level account ($14.99/mo). Once your account is
            created, follow the sync instructions in your Export dashboard.
          </li>
          <li>
            <b>I have an unpaid basic Zoom account.</b> If you already have a
            Zoom account, but it is NOT a paid Pro account, please upgrade your
            account{' '}
            <a target="_blank" rel="noreferrer" href="https://zoom.us/pricing">
              HERE
            </a>{' '}
            before syncing it with the Expert. Once upgraded, follow the sync
            instructions in your Export dashboard.
          </li>
          <li>
            <b>I have a Pro Zoom account already.</b> If you already have a Zoom
            account w/ a Pro-level license, simply follow the sync instructions
            in the user dashboard.
          </li>
        </ul>
      </QA.Wrapper>
      <QA.Text>Connect your Zoom account to The Expert:</QA.Text>
      <QA.Wrapper>
        <ul>
          <li>Sign in to your The Expert account</li>
          <li>
            In your dashboard, you&#39;ll find the link in the red top bar
            displayed through every page
          </li>
          <li>Follow instructions in the red top bar</li>
          <li>
            The red top bar dissapears once you successfuly connected your
            account.
          </li>
        </ul>
      </QA.Wrapper>
      <img src="/docs/connectZoomBar.png" alt="Connect Zoom account" />
    </QA>
    <QA title="How to use Zoom with The Expert?">
      <QA.Text mb={SPACE.PX_30}>
        We&#39;re automatically scheduling Zoom meetings for your consultation
        bookings and distributing Zoom meeting link to your clients via email or
        by displaying it in the account dashboard. You can always find your Zoom
        meeting link in upcoming consultations.
      </QA.Text>
      <img src="/docs/upcomingSessionsZoom.png" alt="Upcoming consultations" />
    </QA>
    <QA title="How to uninstall The Expert Zoom app?">
      <QA.Wrapper>
        <ul>
          <li>
            Login to your Zoom account and navigate to the Zoom App Marketplace
          </li>
          <li>
            Click Manage {'>'} Installed Apps or search for The Expert app
          </li>
          <li>Click The Expert app</li>
          <li>Click uninstall</li>
        </ul>
      </QA.Wrapper>
    </QA>
    <QA title="Zoom installation troubleshooting">
      <QA.Text mb={SPACE.PX_15}>
        When you successfuly connected your Zoom account and you still see this
        message in your dashboard:
      </QA.Text>
      <QA.Text mb={SPACE.PX_15}>
        <b>
          &quot;Complete your Zoom account onboarding. The Expert requires
          licenced or higher zoom user type. Update your zoom plan...&quot;
        </b>
      </QA.Text>
      <QA.Text>Please double-check the following:</QA.Text>
      <QA.Wrapper>
        <ul>
          <li>
            <b>If you have multiple Zoom accounts.</b> Make sure you have your
            pro plan purchased on the Zoom account you connected to The Expert.
            You can verify the installation{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://marketplace.zoom.us/user/installed"
            >
              HERE
            </a>{' '}
            under Manage {'>'} Installed Apps
          </li>
          <li>
            <b>If you have only one Zoom account.</b> Make sure your Zoom user
            has license assigned in your Zoom dahsboard. You can find the
            detailed guide{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://support.zoom.us/hc/en-us/articles/115004976063-Assigning-a-License"
            >
              HERE
            </a>
            .
          </li>
        </ul>
      </QA.Wrapper>
      <QA.Text>
        If you&#39;re having any problems, please contact{' '}
        <a href={`mailto:${EMAILS.EXPERT_SUPPORT}`}>{EMAILS.EXPERT_SUPPORT}</a>{' '}
        or the live chat bubble.
      </QA.Text>
    </QA>
  </Box>
)

export function getStaticProps() {
  return prepareGetStaticNavigationProps()
}

Docs.getLayout = getPublicLayout

export default Docs
